export default "__VITE_ASSET__78663318__"